import { Card, CardContent, CardHeader, LabelValueList, Typography, useRouter } from '@forgeglobal/design-framework'
import { OwnerChip } from 'components/shared/chips/OwnerChip'
import { TradeIntentType, useClientContextQuery } from 'graphql/bindings/AdminBindings'
import { TransactionHistoryRollup } from 'components/shared/TransactionHistoryRollup'
import React, { Fragment } from 'react'
import RightAlign from 'components/shared/RightAlign'
import capitalize from 'lodash/capitalize'

export const ClientContext: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useClientContextQuery({ variables: { opportunityId: match.params.id } })
  const opportunity = data?.opportunity
  const account = opportunity?.account
  const tradeIntentType = opportunity?.trade_intent?.type ?? TradeIntentType.Bid
  const [firstOwner, ...otherOwners] = account?.owners ?? []
  const notesField = account?.notes ?? ''

  return (
    <Card>
      <CardHeader title={(tradeIntentType === TradeIntentType.Bid ? 'Buyer' : 'Seller') + ' Context'} />
      <CardContent>
        <LabelValueList
          items={[
            {
              label: 'Relationships strength',
              value: capitalize(account?.relationship_strength ?? ''),
              isEmpty: !account?.relationship_strength,
            },
            {
              label: 'Relationship sensitivity',
              value: (
                <Fragment>
                  <Typography variant="body1" align="right">
                    {capitalize(account?.relationship_sensitivity ?? '')}
                  </Typography>
                  <Typography variant="body1" align="right">
                    {account?.relationship_notes ?? ''}
                  </Typography>
                </Fragment>
              ),
              isEmpty: !account?.relationship_sensitivity,
            },
            {
              label: 'Owner',
              value: <OwnerChip owner={firstOwner} />,
              isEmpty: !firstOwner,
            },
            {
              label: 'Additional Forge Contact(s)',
              value: (
                <RightAlign>
                  {otherOwners.map(owner => (
                    <OwnerChip owner={owner} key={owner.id} />
                  ))}
                </RightAlign>
              ),
              isEmpty: !otherOwners.length,
            },
            {
              label: 'Transaction history',
              value: <TransactionHistoryRollup deals={account?.deals ?? []} />,
            },
            {
              label: 'Additional information',
              value: notesField,
              isEmpty: !notesField,
              fullWidth: !!notesField,
            },
          ]}
        />
      </CardContent>
    </Card>
  )
}
